'use client';
import React from 'react';

import { Accordion } from '@/components/molecules/accordion';
import AccordionItem, {
  AccordionItemProps,
} from '@/components/molecules/accordion/AccordionItem';
import { cn } from '@/lib/utils';

export interface AccordionListProps {
  accordionList: {
    header: React.ReactNode;
    children: React.ReactNode;
  }[];
}

export type AccordionListItemProps = {
  internal?: {
    ContainerProps?: React.HTMLAttributes<HTMLDivElement>;
    accordionItem?: Partial<AccordionItemProps>;
  };
} & AccordionListProps;

export function AccordionListComponent({
  accordionList,
  internal,
}: AccordionListItemProps) {
  const { accordionItem, ContainerProps } = internal || {};

  return (
    <div
      {...ContainerProps}
      data-tracker-component='accordion'
      className={cn(
        'flex w-full flex-col gap-6 text-left',
        ContainerProps?.className
      )}
    >
      {accordionList?.map((item, index) => (
        <AccordionItem
          {...accordionItem}
          key={index}
          id={String(index)}
          header={item.header}
        >
          {item.children}
        </AccordionItem>
      ))}
      <div className='border-neutral-N10 border-b border-solid' />
    </div>
  );
}

export default function AccordionList(props: AccordionListItemProps) {
  return (
    <Accordion>
      <AccordionListComponent {...props} />
    </Accordion>
  );
}
